import { Box, Grid } from "@mui/system";
import { Autocomplete, IconButton, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import IncomeGapsTable from "./IncomeGapsTable";

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
  cpa_gap: "CPA Gap",
  cpa_income: "CPA Income",
  calculated_cpa_income: "Calculated CPA Income",
  average_deal_cpa: "Average Deal CPA",
  qftd: "QFTD",
  rs_gap: "RS Gap",
  rs_income: "RS Income",
  calculated_rs_income: "Calculated RS Income",
  average_deal_percentage: "Average Deal %"
};
const rows = [
  {
    brand_name: "BetVictor Sport UK",
    brand_id: 2319,
    cpa_gap: "55",
    cpa_income: "$14,855",
    calculated_cpa_income: "$14,800",
    average_deal_cpa: "$246",
    qftd: 62,
    rs_gap: "$0",
    rs_income: "$8,855",
    calculated_rs_income: "$8,855",
    average_deal_percentage: "41%"
  },
  {
    brand_name: "Gentleman Jim Sport UK",
    brand_id: 2367,
    cpa_gap: "1055",
    cpa_income: "$14,855",
    calculated_cpa_income: "$13,800",
    average_deal_cpa: "$246",
    qftd: 62,
    rs_gap: "$0",
    rs_income: "$8,855",
    calculated_rs_income: "$8,855",
    average_deal_percentage: "41%"
  }
];

const IncomeGaps = () => {
  const brandName = [
    { label: "Brand 01" },
    { label: "Brand 02" },
    { label: "Brand 03" },
    { label: "Brand 04" },
  ];

  return (
    <>
      <Grid container spacing={2} alignItems="center" px={2} py={1.5}>
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Income Gaps in MTD
          </Typography>
        </Grid>
        <Grid size={4}>
          <Box display={"flex"} alignItems={"end"} justifyContent={"flex-end"}>
            <Autocomplete
              id="assetOrSiteName"
              disablePortal
              options={brandName}
              getOptionLabel={(option) => option.label}
              size="small"
              sx={{ pt: "8px", width: "275px" }}
              renderInput={(params) => (
                <TextField
                  color="secondary"
                  {...params}
                  required
                  placeholder="Search Brand Name or choose from the list"
                  label="Brand Name"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <SearchIcon
                          sx={{ fontSize: 20, mr: 1, color: "text.secondary" }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <IconButton
              aria-label="fingerprint"
              color="secondary"
              sx={{ ml: 2 }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <IncomeGapsTable tableHeadings={tableHeadings} rows={rows} />
    </>
  );
};

export default IncomeGaps;
